import { PublicClientApplication } from '@azure/msal-browser';

/**
 * Entra-Konfiguration kommt aus Umgebungsvariablen (siehe .env.example und
 * docs/setup/entra-setup.md). Ohne Konfiguration läuft die Shell im Dev-Modus
 * ohne Login — so ist das Gerüst baubar und lokal startbar, bevor die
 * App-Registrierungen existieren.
 */
export const entraConfig = {
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined,
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID as string | undefined,
  apiScope: import.meta.env.VITE_ONE_API_SCOPE as string | undefined,
};

export const authConfigured = Boolean(entraConfig.clientId && entraConfig.tenantId);

export const msalInstance = authConfigured
  ? new PublicClientApplication({
      auth: {
        clientId: entraConfig.clientId!,
        authority: `https://login.microsoftonline.com/${entraConfig.tenantId}`,
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
      },
      cache: {
        // sessionStorage — bewusst, nach einem Fehlschlag in der Praxis:
        //
        // Ursprünglich stand hier 'memoryStorage' (Tokens überleben keinen Reload).
        // Damit weigert sich MSAL, den Redirect-Login überhaupt zu starten:
        // "In-memory storage was selected and storeAuthStateInCookie=false, which
        // would cause the library to be unable to handle the incoming hash."
        // Der Anmeldeknopf tat schlicht nichts.
        //
        // Die Alternative — memoryStorage plus storeAuthStateInCookie — funktioniert,
        // wirft aber bei jedem Seiten-Reload zurück auf den Anmeldebildschirm, weil
        // auch die Kontoliste im Speicher liegt. Für eine Plattform, die den Tag über
        // offen ist, ist das keine Option.
        //
        // Der Sicherheitsgewinn von memoryStorage ist hier ohnehin gering: ein
        // Modul-Bundle läuft mit Shell-Rechten und könnte sich Tokens jederzeit selbst
        // über acquireTokenSilent holen (Konzept Kap. 02 §2.5 sagt das offen). Gegen
        // diese Bedrohung schützt kein Cache-Ort. sessionStorage ist Microsofts
        // Empfehlung für SPAs: beim Schließen des Tabs weg und — anders als
        // localStorage — nicht zwischen Tabs geteilt.
        cacheLocation: 'sessionStorage',
      },
    })
  : null;

export const loginRequest = {
  scopes: entraConfig.apiScope ? [entraConfig.apiScope] : ['openid', 'profile', 'email'],
};
